import type { PrefixedPermissions } from '@dolpheen/apollo'
import type { AccountPermissionFragment } from '@gql'
import { Permission } from '@gql'

const getPermissionKey = (permission: Permission): PrefixedPermissions => `PERMISSION_${permission}`

/**
 * The `$PERMISSION_<code>: Boolean! = false` variables that permission-gated
 * fragment fields (`@include(if: $PERMISSION_…)`) rely on. Injected into EVERY
 * query's variables by both `useQuery` and `useSuspenseQuery` — mutations
 * deliberately do NOT inject, which is why the declarations default to false.
 *
 * NOTE for anything comparing query variables (mocks, cache key assertions):
 * strip these first.
 */
export function getPermissionVariables(
  permissions: AccountPermissionFragment[] | undefined,
): Record<PrefixedPermissions, boolean> {
  const held = new Set(permissions?.map((permission) => permission.code))
  const variables = {} as Record<PrefixedPermissions, boolean>
  for (const code of Object.values(Permission)) {
    variables[getPermissionKey(code)] = held.has(code)
  }

  return variables
}
